/**
 * @name Locator - Dynamic Load
 * Responsible for determining if the PS Quote Form needs to load, and for actually loading the files.
 * @author Rhys Lloyd
 */

//
// Utilities
//
// Dependencies
import * as registry from '@core/registry';

//
// Constants
export const MODULE_NAME = registry.LOCATOR_MODULE;
export const MODULE_SELECTOR = '[data-locator]';
export const ASSETS = [
	'../scripts/hf-locator.module.js',
	'../styles/hf-locator.module.css',
];

//
// Load
export default function load() {
	registry.dynamicLoader(MODULE_NAME, MODULE_SELECTOR, ASSETS);
}



// WEBPACK FOOTER //
// ./project/client/src/site__hf/modules/locator/dynamic-load.js